import React, { useState, useEffect } from "react";
import './international-services.css';
import { Link } from "react-router-dom";
import axios from "axios";
// componentes y estilos de Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation'; // Si quieres las flechitas
import 'swiper/css/pagination'; // Si quieres los puntitos abajo
import { Navigation, Pagination } from 'swiper/modules';

import imgWorld from '../../../../assets/imgs/home-redesign/international.svg';
import imgExpress from '../../../../assets/imgs/home-redesign/express.svg';
import imgGeneral from '../../../../assets/imgs/home-redesign/general.svg';
import imgSpecialized from '../../../../assets/imgs/home-redesign/specialized.svg';
import imgCustomized from '../../../../assets/imgs/home-redesign/customized.svg';
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const InternationalServices = () => {
    /* const services = [
        {
            id: 1,
            imgTitle: imgExpress,
            description: "Carga Express pesando menos de 32 kg por pieza y máximo 100 kg por embarque.",
            url: "/servicios/internacional/express"
        },
        {
            id: 2,
            imgTitle: imgGeneral,
            description: "Nuestra opción para su envío estándar.",
            url: "/servicios/internacional/general"
        },
        {
            id: 3,
            imgTitle: imgSpecialized,
            description: "Cualquier tipo de carga a cualquier parte del mundo.",
            url: "/servicios/internacional/especializado"
        },
        {
            id: 4,
            imgTitle: imgCustomized,
            description: "Customized es nuestra solución de carga totalmente personalizada.",
            url: "/servicios/internacional/customizado"
        }
    ]; */
    const { i18n } = useTranslation();
    const [tNational] = useTranslation("national");
    const [services, setServices] = useState([]);
    const [sectionTitle, setSectionTitle] = useState("");
    const idInternationals = "d45a04ef-618d-40de-ada3-cbe93ffa9770";

    const baseConfig = {
        "express": { id: 1, imgTitle: imgExpress },
        "general": { id: 2, imgTitle: imgGeneral },
        "specialized": { id: 3, imgTitle: imgSpecialized },
        "customized": { id: 4, imgTitle: imgCustomized },
    };

    useEffect(() => {
        const fetchInternationalData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idInternationals}`,
                    {
                    headers: {
                        Authorization: process.env.REACT_APP_PUBLIC_KEY,
                    },
                    }
                );
                
                const isSpanish = i18n.language.startsWith('es');
                const langKey = isSpanish ? 'text_es' : 'text_us';
                const apiData = response.data.textWeb[langKey];

                // Guardamos el título de la sección que viene en el API
                setSectionTitle(apiData.title?.["titulo de sección"] || "Servicios internacionales");

                // Base de URL según idioma
                const urlBase = isSpanish ? '/servicios/internacional/' : '/services/international/';

                // Mapeamos combinando baseConfig con API
                const mergedData = Object.keys(baseConfig).map(key => {
                    const itemApi = apiData[key];
                    const slug = itemApi?.["link-botón-linea"]?.trim() || "";

                    return {
                        ...baseConfig[key],
                        description: itemApi?.texto || "",
                        url: `${urlBase}${slug}`,
                        // Opcional: Si quieres usar el texto del botón del API ("Leer más" / "Learn more")
                        btnText: itemApi?.["texto-botón-linea"]?.trim() || (isSpanish ? "Conoce más" : "Learn more")
                    };
                });

                setServices(mergedData);
            } catch (error) {
                console.error("Error cargando servicios internacionales:", error);
            }
        };

        fetchInternationalData();
    }, [i18n.language]);

    return(
        <div className="container-fluid international-services">
            <div className="row">
                <div className="col title-international">
                    <img src={imgWorld} />
                    <h3>{sectionTitle}</h3>
                </div>
            </div>

            <div className="international-services-desktop">
                <div className="row mt-4 px-2">
                    {services.map((service) => (
                        // Usamos col-12 (móvil), col-md-6 (tablet), col-lg-3 (desktop)
                        <div key={service.id} className="col-3 mb-4">
                            <div className="card-international-home h-100 d-flex flex-column">
                            
                                {/* Imagen del título (Express, General, etc.) */}
                                <div className="card-header-img mb-3">
                                    <img src={service.imgTitle} alt="Service Title" />
                                </div>

                                {/* Descripción */}
                                <div className="card-body-text flex-grow-1">
                                    <p>{service.description}</p>
                                </div>

                                {/* Botón */}
                                <Link 
                                    to={service.url} 
                                    className="btn-tertiary text-decoration-none mt-3" // text-decoration-none es para quitar el subrayado típico de los links
                                >
                                    {tNational("btn-learn-more")}
                                </Link>

                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="international-services-tablet custom-padding">
                <div className="row">
                    <div className="col my-4 position-relative">

                        <div className="custom-prev-in nav-btn-in">
                            <FaLongArrowAltLeft size={18} />
                        </div>
                        <div className="custom-next-in nav-btn-in">
                            <FaLongArrowAltRight size={18} />
                        </div>

                        <Swiper
                            modules={[Navigation]}
                            spaceBetween={0} // Espacio entre cards (en px)
                            navigation={{
                                nextEl: '.custom-next-in',
                                prevEl: '.custom-prev-in',
                            }}
                            breakpoints={{
                                // Configuración para Celular (>= 320px)
                                320: {
                                    slidesPerView: 1, // Muestra 1 card
                                    spaceBetween: 10
                                },
                                // Configuración para Tablet (>= 768px)
                                768: {
                                    slidesPerView: 2, // Muestra 2 cards (¡Lo que pediste!)
                                    spaceBetween: 20
                                }
                            }}
                            className="mySwiper"
                        >
                            {/* Aquí iteramos TODAS las cards, sin separar en grupos */}
                            {services.map((service, index) => (
                                <SwiperSlide key={index} style={{ height: 'auto' }}>
                                    {/* El 'height: auto' en el slide es clave para que Flexbox funcione dentro */}
                                    <div className="card-international-home h-100 d-flex flex-column">
                            
                                        {/* Imagen del título (Express, General, etc.) */}
                                        <div className="card-header-img mb-3">
                                            <img src={service.imgTitle} alt="Service Title" />
                                        </div>

                                        {/* Descripción */}
                                        <div className="card-body-text flex-grow-1">
                                            <p>{service.description}</p>
                                        </div>

                                        {/* Botón */}
                                        <Link 
                                            to={service.url} 
                                            className="btn-tertiary text-decoration-none mt-3" // text-decoration-none es para quitar el subrayado típico de los links
                                        >
                                            {tNational("btn-learn-more")}
                                        </Link>

                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InternationalServices;